import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3000 },
    disabled: { type: Boolean, default: false }
  }

  connect () {
    this.scheduleRefresh()
  }

  disconnect () {
    clearTimeout(this.timeout)
  }

  scheduleRefresh () {
    this.timeout = setTimeout(() => {
      if (this.disabledValue) return

      Turbo.visit(window.location.href, { action: 'replace' })
    }, this.delayValue)
  }
}
